import { render, staticRenderFns } from "./CandlestickChartDisplay.vue?vue&type=template&id=63bd659a&scoped=true"
import script from "./CandlestickChartDisplay.vue?vue&type=script&lang=js"
export * from "./CandlestickChartDisplay.vue?vue&type=script&lang=js"
import style0 from "./CandlestickChartDisplay.vue?vue&type=style&index=0&id=63bd659a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bd659a",
  null
  
)

export default component.exports